// const ShareUrl = {
//     qq: 'http://connect.qq.com/widget/shareqq/index.html?url={{URL}}&title={{TITLE}}&source={{SOURCE}}&desc={{DESCRIPTION}}&pics={{IMAGE}}&summary="{{SUMMARY}}"',
//     qzone: 'http://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url={{URL}}&title={{TITLE}}&desc={{DESCRIPTION}}&summary={{SUMMARY}}&site={{SOURCE}}&pics={{IMAGE}}',
//     weibo: 'https://service.weibo.com/share/share.php?url={{URL}}&title={{TITLE}}&pic={{IMAGE}}&appkey={{WEIBOKEY}}',
//     wechat: 'javascript:',
//     douban: 'http://shuo.douban.com/!service/share?href={{URL}}&name={{TITLE}}&text={{DESCRIPTION}}&image={{IMAGE}}&starid=0&aid=0&style=11',
// };


// /** 
//  *
//  * @functionName: makeUrl
//  * @param: {string} name 可选项为：qq,wechat,weibo
//  * @param: {object} data,属性包括：{title，description,image,weibokey,url}
//  * @return: {string} url,对应选项的分享链接
//  * @description:参照sharejs的makeUrl
//  * @author: hiBruce
//  * @date: 2020-05-25 11:49:44
//  * @version: V1.0.0
// */
// export default function makeUrl(name, data) {
//     return ShareUrl[name].replace(/\{\{(\w)(\w*)\}\}/g, function (m, fix, key) {
//         var nameKey = name + fix + key.toLowerCase();
//         key = (fix + key).toLowerCase();

//         return encodeURIComponent((data[nameKey] === undefined ? data[key] : data[nameKey]) || '');
//     });
// }



var shareModel = {

    /**
     * 分享QQ好友
     * @param  {[type]} title [分享标题]
     * @param  {[type]} url   [分享url链接，默认当前页面链接]
     * @param  {[type]} pic   [分享图片]
     * @return {[type]}       [description]
     */
    qq: function (data) {
        var param = {
            url: data.url || window.location.href,
            desc: data.description, /*分享理由*/
            title: data.title || '', /*分享标题(可选)*/
            summary: data.summary,/*分享描述(可选)*/
            pics: data.image || '',/*分享图片(可选)*/
            site: data.site || '' /*分享来源 (可选) */
        };
        var s = [];
        for (var i in param) {
            s.push(i + '=' + encodeURIComponent(param[i] || ''));
        }
        var targetUrl = "http://connect.qq.com/widget/shareqq/iframe_index.html?" + s.join('&');
        return targetUrl;
        // window.open(targetUrl, 'qq', 'height=520, width=720');
    },

    /**
      * 微信分享
      * @return {[type]} [description]
      */
    // wechat: function () {
    //     var url = window.location.href,
    //         encodePath = encodeURIComponent(url),
    //         targetUrl = 'http://qr.liantu.com/api.php?text=' + encodePath;
    //     return targetUrl;
    //     // window.open(targetUrl, 'weixin', 'height=320, width=320');
    // },

    wechat: function (data) {
        var param = {
            url: data.url || window.location.href,
            desc: data.description, /*分享理由*/
            title: data.title || '', /*分享标题(可选)*/
            summary: data.summary,/*分享描述(可选)*/
            pics: data.image || '',/*分享图片(可选)*/
            site: data.site || '' /*分享来源 (可选) */
        };
        var s = [];
        for (var i in param) {
            s.push(i + '=' + encodeURIComponent(param[i] || ''));
        }
        var targetUrl = 'http://qr.liantu.com/api.php?text=' + s.join('&');
        return targetUrl;
        // window.open(targetUrl, 'qq', 'height=520, width=720');
    },

    /**
      * 分享新浪微博
      * @param  {[type]} title [分享标题]
      * @param  {[type]} url   [分享url链接，默认当前页面]
      * @param  {[type]} pic   [分享图片]
      * @return {[type]}       [description]
      */
    weibo: function (data) {
        var param = {
            type: '3',
            appkey: '', /** 您申请的应用appkey,显示分享来源(可选)*/
            pic: data.image || '', /**分享图片的路径(可选)*/
            ralateUid: '', /**关联用户的UID，分享微博会@该用户(可选)*/
            rnd: new Date().valueOf(),
            url: data.url || window.location.href,
            desc: data.description, /*分享理由*/
            title: data.description || '', /*分享标题(可选)*/
            summary: data.summary,/*分享描述(可选)*/
            pics: data.image || '',/*分享图片(可选)*/
            site: data.site || '' /*分享来源 (可选) */
        }
        var temp = [];
        for (var p in param) {
            temp.push(p + '=' + encodeURIComponent(param[p] || ''))
        }
        var targetUrl = 'http://service.weibo.com/share/share.php?' + temp.join('&');
        return targetUrl;
        // window.open(targetUrl, 'sinaweibo', 'height=430, width=400');
    }
};

export default function makeUrl(name, data) {
    return shareModel[name] ? shareModel[name](data) : ""
}